import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Typography,
  Box,
  List,
  ListItem,
  CircularProgress,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Container,
  Paper
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import FlagIcon from '@mui/icons-material/Flag';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedIcon from '@mui/icons-material/Verified';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';



import Navbar from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';

function CourseDetailsPage() {
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [chapterCount, setChapterCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [chapterTitle, setChapterTitle] = useState('');
  const [chapterDescription, setChapterDescription] = useState('');
  const [chapterError, setChapterError] = useState('');
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.user;
  const [viewedChapters, setViewedChapters] = useState([]);
  const [editingField, setEditingField] = useState('');

  const [editValue, setEditValue] = useState('');

  const handleSaveCourseEdit = async (field, value) => {
    try {
      const response = await fetch(`http://196.216.9.34:5021/api/courses/${course.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ [field]: value }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        alert(data.message || 'Failed to update course');
        return;
      }
  
      // Update local course state with the updated course data from the server
      updateCourse(data.course);
    } catch (error) {
      console.error('Error updating course:', error);
      alert('An error occurred while updating the course.');
    }
  };
  
  const updateCourse = (updatedData) => {
    console.log('Update course with:', updatedData);
    setCourse(updatedData);
  };
  
  

  useEffect(() => {
    if (editingField) {
      setEditValue(course[editingField]); // Populate with current content
    }
  }, [editingField]);



  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const res = await fetch(`http://196.216.9.34:5020/api/courses/${courseId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to fetch course');
        
        setCourse(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchChapters = async () => {
      try {
        const res = await fetch(`http://196.216.9.34:5020/api/courses/${courseId}/chapters`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to fetch chapters');
        setChapters(data.chapters || []);
      } catch (err) {
        console.error(err.message);
      }
    };

    const fetchViewedChapters = async () => {
      try {
        const res = await fetch(`http://196.216.9.34:5020/api/courses/views-chapters`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setViewedChapters(data.viewedChapterIds || []);
      } catch (err) {
        console.error('Error fetching viewed chapters:', err);
      }
    };

    const fetchChapterCount = async () => {
      try {
        const res = await fetch(`http://196.216.9.34:5020/api/courses/${courseId}/chapter-count`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to fetch chapter count');
        setChapterCount(data.chapterCount || 0);
      } catch (err) {
        console.error('Error fetching chapter count:', err);
      }
    };

    fetchViewedChapters();
    fetchCourse();
    fetchChapters();
    fetchChapterCount();
  }, [courseId, token]);

  const handleAddChapter = async () => {
    setChapterError('');
    if (!chapterTitle.trim()) {
      setChapterError('Chapter title is required');
      return;
    }

    try {
      const res = await fetch(`http://196.216.9.34:5020/api/courses/${courseId}/chapters`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: chapterTitle,
          description: chapterDescription,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to add chapter');

      setChapters(prev => [...prev, data.chapter]);
      setChapterCount(prev => prev + 1); // Update chapter count on add
      setChapterTitle('');
      setChapterDescription('');
      setModalOpen(false);
    } catch (err) {
      setChapterError(err.message);
    }
  };

  if (loading) return <Box p={4}><CircularProgress /></Box>;
  if (error) return <Alert severity="error" sx={{ m: 4 }}>{error}</Alert>;
  if (!course) return null;

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh' }}>
    <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '50vh',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.2))',
      zIndex: 0,

    }}
    
  />
  <LeftNavbar />
  
  <Container
  maxWidth="md"
  sx={{
    mt: 10,
    mb: 5,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    mx: 'auto', // horizontally center
    pl: { xs: 2, sm: 4 },
    pr: { xs: 2, sm: 4 },
  }}
>

    <Navbar style={{ marginBottom: "25px" }} />
    <Breadcrumb style={{ mt: 55 }} currentPage="Course Details" />

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
        mt={5}
        
      >
        
        <Box display="flex" alignItems="center" gap={1} mt={2} >
          <Typography variant="h4" fontWeight="bold" flexGrow={1}>
            {course.title}
          </Typography>
          {user?.role === 'instructor' && (
          <IconButton
            size="small"
            onClick={() => {
              setEditingField('title');
              setEditValue(course.title);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          )}
        </Box>
        {user?.role === 'instructor' && (
          <Button
            variant="contained"
            color="warning"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => setModalOpen(true)}
          >
            Add Chapter
          </Button>
        )}
      </Box>

      <Paper 
        elevation={6}
        sx={{
          p: 3,
          height: '100%',
          display: 'flex',
          borderRadius: 4,
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)', 
          flexDirection: 'column',
          justifyContent: 'space-between',
          borderTop: '3px solid #ff6600',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: 6,
            cursor: 'pointer',
          },
        }}
      
      >
      <Box display="flex" alignItems="center" gap={1} mt={2}>
  <DescriptionIcon color="primary" />
  <Typography variant="subtitle1" fontWeight="bold">
    Description
  </Typography>
  {user?.role === 'instructor' && (
    <IconButton size="small" onClick={() => setEditingField('description')}>
      <EditIcon fontSize="small" />
    </IconButton>
  )}
</Box>
<Typography mb={2}>{course.description}</Typography>

<Box display="flex" alignItems="center" gap={1}>
  <FlagIcon color="primary" />
  <Typography variant="subtitle1" fontWeight="bold">
    Objectives
  </Typography>
  {user?.role === 'instructor' && (
    <IconButton size="small" onClick={() => setEditingField('objectives')}>
      <EditIcon fontSize="small" />
    </IconButton>
  )}
</Box>
<Typography mb={2}>{course.objectives}</Typography>

<Box display="flex" alignItems="center" gap={1}>
  <AccessTimeIcon color="primary" />
  <Typography variant="subtitle1" fontWeight="bold">
    Duration
  </Typography>
  {user?.role === 'instructor' && (
    <IconButton size="small" onClick={() => setEditingField('duration')}>
      <EditIcon fontSize="small" />
    </IconButton>
  )}
</Box>
<Typography mb={2}>{course.duration}</Typography>

<Box display="flex" alignItems="center" gap={1}>
  <VerifiedIcon color="primary" />
  <Typography variant="subtitle1" fontWeight="bold">
    Certification
  </Typography>
  {user?.role === 'instructor' && (
    <IconButton size="small" onClick={() => setEditingField('certification')}>
      <EditIcon fontSize="small" />
    </IconButton>
  )}
</Box>
<Typography
  sx={{
    display: 'inline-block',
    backgroundColor: 'white',
    color: '#ff6600',
    padding: '4px 12px',
    borderRadius: '999px',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    mb: 1
  }}
>
  {course.certification}
</Typography>

      </Paper>

      {user?.role === 'student' && (
        <Box mb={2}>
          <Typography variant="subtitle1" color="textSecondary">
            Progress: {viewedChapters.length} of {chapterCount} chapters viewed
          </Typography>
          <Box display="flex" alignItems="center" mt={1}>
            <Box flexGrow={1} mr={2}>
              <Box
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: '#eee',
                  overflow: 'hidden'
                }}
              >
                <Box
                  sx={{
                    width: `${chapterCount > 0 ? Math.min((viewedChapters.length / chapterCount) * 100, 100) : 0}%`,
                    height: '100%',
                    backgroundColor: '#1976d2',
                    transition: 'width 0.4s ease'
                  }}
                />
              </Box>
            </Box>
            <Typography variant="caption" color="textSecondary">
              {chapterCount > 0 ? Math.round((viewedChapters.length / chapterCount) * 100) : 0}%
            </Typography>
          </Box>
        </Box>
      )}

      <Typography variant="h5" gutterBottom>Chapters</Typography>
      {chapters.length === 0 ? (
        <Typography>No chapters added yet.</Typography>
      ) : (
        <List>
          {chapters.map((ch) => (
            <ListItem
              key={ch.id}
              sx={{
                backgroundColor: '#fff',
                borderRadius: 2,
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                borderLeft: '3px solid #ff6600',
                mb: 2,
                p: 2,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                <MenuBookIcon color="primary" sx={{ mr: 1 }} />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">{ch.title}</Typography>
                  <Typography>{ch.description}</Typography>
                </Box>
              </Box>
              {Array.isArray(viewedChapters) && viewedChapters.includes(ch.id) && (
                <CheckCircleIcon color="info" fontSize="large" sx={{ ml: 1 }} />
              )}

              <Button
                variant="outlined"
                color="primary"
                onClick={async () => {
                  try {
                    // Send view tracking request
                    await fetch(`http://196.216.9.34:5020/api/courses/${ch.id}/track-view`, {
                      method: 'POST',
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    });
                  } catch (err) {
                    console.error('Failed to track view:', err);
                  } finally {
                    // Navigate to the chapter regardless of tracking result
                    navigate(`/courses/${courseId}/chapters/${ch.id}`, { state: { user } });
                  }
                }}
                sx={{ ml: 2, alignSelf: 'center' }}
                startIcon={<VisibilityIcon />}
              >
                VIEW
              </Button>
            </ListItem>
          ))}
        </List>
      )}

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Add New Chapter</DialogTitle>
        <DialogContent>
          {chapterError && <Alert severity="error" sx={{ mb: 2 }}>{chapterError}</Alert>}
          <TextField
            label="Chapter Title"
            fullWidth
            value={chapterTitle}
            onChange={(e) => setChapterTitle(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Chapter Description"
            fullWidth
            multiline
            rows={3}
            value={chapterDescription}
            onChange={(e) => setChapterDescription(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          <Button onClick={handleAddChapter} variant="contained" color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(editingField)}
        onClose={() => setEditingField('')}
        fullWidth
        maxWidth="md" // or "lg" for even larger
        sx={{
          '& .MuiDialog-paper': {
            minWidth: '600px', // or '800px' if you want bigger
          }
        }}
      >
        <DialogTitle>Edit {editingField}</DialogTitle>
        <DialogContent>
          <TextField
          style={{ marginTop: "5px" }}
            fullWidth
            multiline
            rows={editingField === 'objectives' || editingField === 'description' ? 4 : 1}
            label={`Edit ${editingField}`}
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingField('')}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              handleSaveCourseEdit(editingField, editValue);
              setEditingField('');
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>


    </Container>
    </Box>
  );
}

export default CourseDetailsPage;
